import React from 'react';
import canUseDOM from "../canUseDOM.mjs";
var useEnhancedEffect = canUseDOM() ? React.useLayoutEffect : React.useEffect;
export default useEnhancedEffect;
//# sourceMappingURL=useEnhancedEffect.mjs.map